import { Box, IconButton, Popover, Typography } from '@mui/material'
import { useState } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

interface DeviationInfoProps {
  text: string
}

export default function DeviationInfo({ text }: DeviationInfoProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: any) => {
    setAnchorEl(event.target as HTMLDivElement)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton color="info" onClick={(e) => handleClick(e)}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box
          sx={{
            p: 1,
            maxWidth: 500,
            minWidth: 300
          }}>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>{text}</Typography>
        </Box>
      </Popover>
    </>
  );
}
